import type { FieldValue } from '../../formBuilder'
import type { Validator } from '../Validator'
import { validateCompleteError, validateCompleteSuccess } from '../Validator'

export const phoneAndEmailAtLeastOneFilledValidator = (
    options: Validator.options
): Validator.validatorMultiple<{
    phone: FieldValue<'phone', 'input'>
    email: FieldValue<'email', 'input'>
}> => ({
    isAsync: false,
    validate: fields => {
        if (
            (typeof fields.phone.value === 'undefined' && typeof fields.email.value === 'undefined') ||
            (typeof fields.phone.value === 'undefined' && fields.email.value === '') ||
            (fields.phone.value === '' && typeof fields.email.value === 'undefined') ||
            (fields.phone.value === '' && fields.email.value === '')
        ) {
            return validateCompleteError(options, 'Compila almeno uno dei due campi: cellulare o email')
        }

        return validateCompleteSuccess()
    },
})
